export const isEmpty = (data = {}) => {
  if (Array.isArray(data))
    return data.length === 0
  else
    return isEmpty(Object.keys(data))
}

export const buildRoute = ({route, location}) => (location.pathname === '/' ? route : `${route}?nextRoute=${location.pathname.slice(1)}${encodeURIComponent(location.search)}`)

export const fullName = (user = {}) => (`${user.firstName} ${user.lastName}`)

export const firstLetterUpperCased = (data = '') => data[0].toUpperCase()

export const toSentence = (parts = []) => {
  if (parts.length < 2)
    return parts.join('')

  return `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`
}

export const activePath = ({pathname, basePath = '', path}) => {
  const currentPath = path.replace(basePath, '')

  if (currentPath.length > 0) {
    return pathname.includes(currentPath)
  } else {
    return pathname === basePath
  }
}
